/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAudienceConditionPayloadFromJSON, ApiAudienceConditionPayloadToJSON, } from './ApiAudienceConditionPayload';
export function ApiAudienceConditionGroupPayloadFromJSON(json) {
    return ApiAudienceConditionGroupPayloadFromJSONTyped(json, false);
}
export function ApiAudienceConditionGroupPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conditions': !exists(json, 'conditions') ? undefined : (json['conditions'].map(ApiAudienceConditionPayloadFromJSON)),
    };
}
export function ApiAudienceConditionGroupPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conditions': value.conditions === undefined ? undefined : (value.conditions.map(ApiAudienceConditionPayloadToJSON)),
    };
}
